"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var combinationsNormalizer = function (response) {
    var _a;
    if ((response === null || response === void 0 ? void 0 : response.status) === 400) {
        return __assign(__assign({}, response), { data: {} });
    }
    var optionsByProduct = Object.entries((_a = response.data) === null || _a === void 0 ? void 0 : _a.data).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], options = _a[1];
        var normalizedOptions = Object.entries(options).reduce(function (optionsAcc, _a) {
            var _b;
            var _c, _d, _e;
            var optionKey = _a[0], option = _a[1];
            return __assign(__assign({}, optionsAcc), (_b = {}, _b[optionKey] = {
                price: {
                    discount: (_c = option.price) === null || _c === void 0 ? void 0 : _c.discount,
                    price: (_d = option.price) === null || _d === void 0 ? void 0 : _d.price,
                    originalPrice: (_e = option.price) === null || _e === void 0 ? void 0 : _e.original_price,
                },
                skus: option.skus,
                freeSkus: option.free_skus,
            }, _b));
        }, {});
        return __assign(__assign({}, acc), (_b = {}, _b[key] = normalizedOptions, _b));
    }, {});
    return __assign(__assign({}, response), { data: optionsByProduct });
};
exports.default = combinationsNormalizer;
